import React from 'react';

import Chip, {ChipProps} from 'ui-library/chips/Chip';

export default function LoadingChip(props: Omit<ChipProps, 'text'>): JSX.Element {
  return <Chip {...props} text="Loading..." />;
}
